export function loadSpecial(specialId) {
  return {
    type: 'LOAD_SPECIAL',
    specialId,
  };
}

export function loadSpecialCompletion(specialId, data, error) {
  return {
    type: 'LOAD_SPECIAL_COMPLETION',
    specialId,
    data,
    error,
  };
}
